const SourceDisplayType = Object.freeze({
  VALUE: 'VALUE',
  PERCENT_SHARE: 'PERCENT_SHARE'
})
export default SourceDisplayType
// RESERVE BELOW
